import { useRoute } from "#imports";
export function useShowTranslationKeys() {
  const route = useRoute();
  return Boolean(route.query?.showTranslationKeys);
}
